import { type FC, useState } from "react";
import { Select, type SelectOptionType } from "@onshopfront/components";
import { useShopfrontDispatch } from "../../_Bootstrap/hooks";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import { getOption } from "../../Utilities/Platform/Options/Options";
import { openDrawer, type OpenDrawerOptions } from "../../Workers/HardwareConnect/HardwareConnectEvents";
import Button from "../Buttons/Button";
import PopupManager from "../Popups/PopupManager";

interface Props {
    options: OpenDrawerOptions;
}

export const OpenRegisterReasonDialog: FC<Props> = ({ options }) => {
    const dispatch = useShopfrontDispatch();

    const predefinedReasons = getOption("predefined_cash_drawer_reasons");
    const [ viewOther, setViewOther ] = useState(predefinedReasons.length === 0);
    const [ reason, setReason ] = useState(predefinedReasons.length ? predefinedReasons[0] : "");

    return (
        <>
            <div className="max-w-[500px] w-[95vw]">
                <p>What is the reason for opening the cash drawer?</p>
                {predefinedReasons.length !== 0 && (
                    <Select
                        value={viewOther ? {
                            label: "Other",
                            value: null,
                        } : {
                            label: reason,
                            value: reason,
                        }}
                        onChange={(val: SelectOptionType<string | null>) => {
                            if(val.value === null) {
                                setViewOther(true);
                                setReason("");
                            } else {
                                setViewOther(false);
                                setReason(val.value);
                            }
                        }}
                        options={[
                            ...predefinedReasons.map(reason => ({
                                label: reason,
                                value: reason,
                            })),
                            {
                                label: "Other",
                                value: null,
                            },
                        ]}
                    />
                )}
                {viewOther && (
                    <textarea
                        className={(predefinedReasons.length === 0 ? "" : "mt-4 ") + "w-full resize-y"}
                        value={reason}
                        onChange={(e) => {
                            setReason(e.currentTarget.value);
                        }}
                    />
                )}
            </div>
            <div className="buttons">
                <Button
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                    classes={[ "button-cancel" ]}
                >
                    Cancel
                </Button>
                <Button
                    disabled={!reason.trim()}
                    onClick={() => {
                        if(reason.trim() === "") {
                            PopupManager.error("Please specify a reason for opening the cash drawer");

                            return;
                        }

                        dispatch(hideDialog());
                        openDrawer({
                            ...options,
                            reason,
                        });
                    }}
                    classes={[ "button-primary" ]}
                >
                    Open
                </Button>
            </div>
        </>
    );
};
